var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoColors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.355 100.969v61.349c0 4.288-3.48 7.759-7.772 7.759H74.414a.776.776 0 01-.777-.776v-61.349c0-4.285 3.478-7.759 7.772-7.759h13.168c.43 0 .778.35.778.776z",
    fill: "url(#logo_colors_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.757 8.14v71.805a.776.776 0 01-.777.776H44.73c-4.296 0-7.774-3.476-7.774-7.759V1.157c0-.428.346-.773.777-.773h13.249c4.296 0 7.774 3.47 7.774 7.756z",
    fill: "url(#logo_colors_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.757 137.022v55.193c0 4.283-3.478 7.756-7.774 7.756H37.735a.775.775 0 01-.778-.776v-55.19c0-4.285 3.478-7.758 7.774-7.758H57.98c.432 0 .778.349.778.775z",
    fill: "url(#logo_colors_svg__paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.736 156.005v36.209c0 4.283-3.478 7.756-7.77 7.756H.777a.775.775 0 01-.777-.776v-36.208c0-4.286 3.48-7.759 7.774-7.759H20.96c.432 0 .777.349.777.778z",
    fill: "url(#logo_colors_svg__paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.355 38.063v31.451a.777.777 0 01-.778.778H81.41c-4.294 0-7.772-3.473-7.772-7.758V31.08c0-.426.347-.776.777-.776h13.169c4.29 0 7.772 3.473 7.772 7.759z",
    fill: "url(#logo_colors_svg__paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.736 8.143v36.213a.775.775 0 01-.777.776H7.774C3.48 45.132 0 41.66 0 37.378V1.161C0 .73.348.387.777.387h13.19c4.291 0 7.77 3.47 7.77 7.756z",
    fill: "url(#logo_colors_svg__paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.002 199.224v-51.565c0-4.936-1.964-9.673-5.46-13.164-6.354-6.341-12.708-12.675-19.061-19.015a18.676 18.676 0 00-13.187-5.452h-51.665a.778.778 0 00-.777.776v51.563a18.6 18.6 0 005.462 13.166l19.056 19.013A18.667 18.667 0 00147.557 200h51.667c.43 0 .778-.349.778-.776z",
    fill: "url(#logo_colors_svg__paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200.002.776V52.34c0 4.936-1.964 9.673-5.46 13.164-6.354 6.34-12.708 12.675-19.061 19.015a18.675 18.675 0 01-13.187 5.452h-51.665a.778.778 0 01-.777-.776V37.633c0-4.938 1.964-9.675 5.462-13.166L134.37 5.454A18.67 18.67 0 01147.557 0h51.667c.43 0 .778.35.778.776z",
    fill: "url(#logo_colors_svg__paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_colors_svg__paint0_linear",
    x1: 71.457,
    y1: 100.42,
    x2: 104.959,
    y2: 166.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_colors_svg__paint1_linear",
    x1: 34.769,
    y1: 0.645,
    x2: 76.252,
    y2: 72.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_colors_svg__paint2_linear",
    x1: 34.769,
    y1: 136.454,
    x2: 63.542,
    y2: 199.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_colors_svg__paint3_linear",
    x1: -2.182,
    y1: 155.372,
    x2: 13.41,
    y2: 203.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_colors_svg__paint4_linear",
    x1: 71.457,
    y1: 30.434,
    x2: 84.161,
    y2: 74.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_colors_svg__paint5_linear",
    x1: -2.182,
    y1: 0.532,
    x2: 13.412,
    y2: 48.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_colors_svg__paint6_linear",
    x1: 100.802,
    y1: 110.321,
    x2: 117.187,
    y2: 214.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_colors_svg__paint7_linear",
    x1: 200.002,
    y1: 0,
    x2: 110.03,
    y2: 90.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })))));
}

export default SvgLogoColors;